import { DEFINITIONS as MENTION_DEFINITIONS } from '@xing-com/content-editor-plugin-mention';

import { MENTION_TYPENAME, SERIALIZATION } from '../constants';

const DEFINITIONS = {
  type: MENTION_DEFINITIONS.type,
  __typename: MENTION_TYPENAME,
};

const mentionMarkSerializer = ({ node, matchMark, createMark, direction }) => {
  if (
    matchMark({
      node,
      match: DEFINITIONS,
    })
  ) {
    if (direction === SERIALIZATION) {
      let { start, end, data: { userId } = {} } = node;
      if (start === end) return;
      return createMark({
        node: { start, end },
        definitions: DEFINITIONS,
        data: { start, end, userId },
      });
    }
    let { __typename, start, end, text, ...data } = node;
    return createMark({
      node,
      definitions: DEFINITIONS,
      data,
    });
  }
};

export { mentionMarkSerializer };
